// removed by extract-text-webpack-plugin
module.exports = {"container":"_2P1i","wrapper":"_1Jos","textContainer":"_2iBz","text":"SvuX","title":"_2pbz","teamMemberContainer":"_3s5p","teamMembers":"_3CIV","carousel":"_31xI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/JobDescription/Team/styles.scss
// module id = 497
// module chunks = 0